// Major colleges/universities by city in US and India
// Organized by city for easy filtering

export const COLLEGES_BY_CITY = {
  // US Cities
  'Los Angeles': [
    'UCLA',
    'USC (University of Southern California)',
    'Loyola Marymount University',
    'California State University, Los Angeles',
    'Occidental College',
    'Pepperdine University',
    'Other'
  ],
  'New York': [
    'Columbia University',
    'NYU (New York University)',
    'Fordham University',
    'The New School',
    'CUNY (City University of New York)',
    'Pace University',
    'Other'
  ],
  'Boston': [
    'Harvard University',
    'MIT',
    'Boston University',
    'Northeastern University',
    'Boston College',
    'Tufts University',
    'Other'
  ],
  'Chicago': [
    'University of Chicago',
    'Northwestern University',
    'DePaul University',
    'Loyola University Chicago',
    'University of Illinois Chicago',
    'Other'
  ],
  'San Francisco': [
    'Stanford University',
    'UC Berkeley',
    'San Francisco State University',
    'University of San Francisco',
    'Santa Clara University',
    'Other'
  ],
  'Seattle': [
    'University of Washington',
    'Seattle University',
    'Seattle Pacific University',
    'Other'
  ],
  'Austin': [
    'University of Texas at Austin',
    'Texas State University',
    'St. Edward\'s University',
    'Other'
  ],
  
  // India Cities
  'Mumbai': [
    'IIT Bombay',
    'University of Mumbai',
    'VJTI',
    'SPIT',
    'DJ Sanghvi',
    'Jai Hind College',
    'St. Xavier\'s College',
    'Other'
  ],
  'Delhi': [
    'IIT Delhi',
    'Delhi University',
    'JNU (Jawaharlal Nehru University)',
    'Jamia Millia Islamia',
    'DTU (Delhi Technological University)',
    'NSUT',
    'Other'
  ],
  'Bangalore': [
    'IISc Bangalore',
    'IIM Bangalore',
    'IIIT Bangalore',
    'Bangalore University',
    'Christ University',
    'PES University',
    'RV College of Engineering',
    'Other'
  ],
  'Chennai': [
    'IIT Madras',
    'Anna University',
    'Loyola College',
    'Madras Christian College',
    'SRM University',
    'VIT Chennai',
    'Other'
  ],
  'Hyderabad': [
    'IIT Hyderabad',
    'IIIT Hyderabad',
    'University of Hyderabad',
    'BITS Pilani Hyderabad',
    'Osmania University',
    'Other'
  ],
  'Pune': [
    'COEP',
    'PICT',
    'Symbiosis',
    'Fergusson College',
    'MIT Pune',
    'VIT Pune',
    'Other'
  ],
  'Kolkata': [
    'IIT Kharagpur',
    'Jadavpur University',
    'Presidency University',
    'St. Xavier\'s College',
    'Other'
  ]
};

// Get colleges for a specific city
export const getCollegesForCity = (city) => {
  if (!city) return [];
  
  // Try exact match first
  if (COLLEGES_BY_CITY[city]) {
    return COLLEGES_BY_CITY[city];
  }
  
  // Try case-insensitive match
  const cityKey = Object.keys(COLLEGES_BY_CITY).find(
    key => key.toLowerCase() === city.toLowerCase()
  );
  
  if (cityKey) {
    return COLLEGES_BY_CITY[cityKey];
  }
  
  // Return generic options if city not found
  return ['Other'];
};

// Get current year for graduation year dropdown
export const getCurrentYear = () => new Date().getFullYear();

// Get graduation year options (current year to +8 years)
export const getGraduationYearOptions = () => {
  const currentYear = getCurrentYear();
  const years = [];
  
  for (let i = 0; i <= 8; i++) {
    years.push(currentYear + i);
  }
  
  return years;
};
